import { ExternalLink } from 'react-feather';
import styled from '@emotion/styled';
import { buildKolMailTo } from '@trinity/chat-components/utils';
import { OpenAddressButton } from './OpenMapsButton';

type EmailMailToLinkProps = {
  email: string;
  className?: string;
};

export const EmailMailToLink = ({ email, className }: EmailMailToLinkProps) => {
  return (
    <EmailMailTo className={className} href={buildKolMailTo({ email })} target="_blank" rel="noreferrer">
      <EmailLinkText>{email}</EmailLinkText>
      <StyledLinkIcon size={14} />
    </EmailMailTo>
  );
};

type OpenAddressCellLinkProps = {
  address: string;
  className?: string;
};

export const OpenAddressCellLink = ({ address, className }: OpenAddressCellLinkProps) => {
  return (
    <AddressCellLink className={className}>
      <OpenAddressButton address={address} />
    </AddressCellLink>
  );
};

const StyledLinkIcon = styled(ExternalLink)(({ theme }) => ({
  color: theme.palette.hyperlink,
  transition: 'all 150ms',
  flexShrink: 0,
  marginLeft: 4,
  height: 16,
}));

const EmailMailTo = styled.a(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  transition: 'all 150ms',
  overflow: 'hidden',
  height: '100%',

  ':hover': {
    color: theme.palette.hyperlink,
  },

  [`> ${String(StyledLinkIcon)}`]: {
    opacity: 0,
  },

  [`:hover > ${String(StyledLinkIcon)}`]: {
    opacity: 1,
  },
}));

const EmailLinkText = styled.div({
  height: '100%',
  wordBreak: 'break-all',
});

const AddressCellLink = styled.div({
  width: '100%',
});
